import { useEffect } from "react";
import "../App.css";
// video demos
import SkPoster from "../assets/SK-Design-Poster.png";
import Tradeball1 from "../assets/demos/Tradeball - Explore.mp4";
import Tradeball2 from "../assets/demos/Tradeball - Home.mp4";
import ResetaPlusAuth2 from "../assets/demos/ResetaPlus - Auth Pages 2.mp4";
import ResetaPlus from "../assets/demos/ResetaPlus - Dashboard.mp4";
import FlutterPlayground from "../assets/demos/Flutter UI Playground.mp4";
import SikaVue from "../assets/demos/sika-vue.mp4";
// sfx utils
import { playElementHover } from "../utils/sfx.js";
// bootstrap
import { Button, OverlayTrigger } from "react-bootstrap";

export default function Projects() {

	useEffect(() => {
		// grab elements and add "show" class after mount for animation
		const projectNav = document.querySelector(".project-nav");
		setTimeout(() => {
			projectNav?.classList.add("show");
		}, 100); // small delay
	}, []);

	return (<div className="content" style={{ height: "100vh" }}>
		<div className="image-bg"></div>

		<div className="project-nav">
			<Button href="#saling-kamay" onClick={playElementHover}>1</Button>
			<Button href="#tradeball" onClick={playElementHover}>2</Button>
			<Button href="#resetaplus" onClick={playElementHover}>3</Button>
			<Button href="#flutter" onClick={playElementHover}>4</Button>
			<Button href="#sika-vue" onClick={playElementHover}>5</Button>
		</div >

		<div className="screen-container">
			<div id="saling-kamay" className="screen">
				<div className="w-50 d-flex justify-content-center">
					<img src={SkPoster} width="75%" height="90%" alt="Saling-Kamay design poster" />
				</div>
				<div className="project-desc w-50">
					<OverlayTrigger placement="left" overlay={<div className="tooltip">Click to view Facebook Page.</div>}>
						<p className="project-title glitch" data-text="Saling-Kamay: Custom-built Filipino Sign Language Video Dataset for a Two-Way Translation System Using MediaPipe, LSTM, and NLP" onClick={() => window.open('https://www.facebook.com/salingkamay', '_blank')}>
							Saling-Kamay: Custom-built Filipino Sign Language Video Dataset for a Two-Way Translation System Using MediaPipe, LSTM, and NLP
						</p>
					</OverlayTrigger>
					<div className="d-flex flex-row justify-items between">
						<p className="project-subtitles w-50"><b>Date:</b> Jan 2025 - Aug 2025</p>
						<p className="project-subtitles w-50"><b>Type:</b> Thesis Project</p>
					</div>
					<p className="project-subtitles"><b>Roles:</b> Project Proponent, Head Researcher, Events Coordinator</p>
					<p className="project-subtitles"><b>Technologies:</b> Machine Learning, Neural Network, Natural Language Processing, Computer Vision, Machine Translation</p>
					<p>There exists a communication gap between the Deaf and hearing communities in the Philippines, brought about by a lack of awareness towards deaf needs and limited research advancements into <span>assistive technologies</span> centered around <span>Filipino Sign Language (FSL)</span>. To help bridge the communication gap and further contribute to research and development of assistive technologies, the proponents developed a <span>custom-built video dataset of over 100 conversational FSL signs</span>, titled "Saling-Kamay", that functions as a foundational resource for Deaf assistive technologies; including two prototypes that utilizes the dataset: (1) a KP-LSTM gesture recognition model, and (2) an NLP algorithm for FSL-to-Filipino grammar translation.</p>
					<button onClick={() => window.open('https://www.facebook.com/salingkamay', '_blank')} className="project-button">View Facebook Page</button>
				</div>
			</div>
			<div id="tradeball" className="screen">
				<div className="d-flex flex-column justify-content-center align-items-center h-50 w-50">
					<video height="100%" width="100%" autoPlay="true" loop="true" muted="true">
						<source src={Tradeball2} type="video/mp4" />
					</video>
					<video height="100%" width="100%" autoPlay="true" loop="true" muted="true">
						<source src={Tradeball1} type="video/mp4" />
					</video>
				</div>
				<div className="project-desc w-50">
					<p className="project-title glitch" data-text="TradeBall: A Web-Based Platform for Safer Consumer-to-Consumer (C2C) Pokémon Card Transactions">TradeBall: A Web-Based Platform for Safer Consumer-to-Consumer (C2C) Pokémon Card Transactions</p>
					<div className="d-flex flex-row justify-items between">
						<p className="project-subtitles w-50"><b>Date:</b> Mar 2025 - Present</p>
						<p className="project-subtitles w-50"><b>Type:</b> Commissioned Project</p>
					</div>
					<p className="project-subtitles"><b>Roles:</b> Frontend developer, freelance programmer</p>
					<p className="project-subtitles"><b>Technologies:</b> React, Bootstrap, Pokémon TCG API</p>
					<p>TradeBall is a web-based application and consumer-to-consumer (C2C) store hub designed to provide a secure and user-friendly environment for <span>Pokémon card collectors</span> to <span>buy, sell, and trade</span>. The platform focuses on consumer safety by integrating clear transaction flows, escrow-inspired mechanics, and an intuitive interface tailored for both casual fans and serious collectors. Featuring eye-catching responsive UI designs and a user experience tailored for Pokémon fans, card collectors, and hobbyists, TradeBall aims to become a safe space of card trading. This thesis project is currently in progress and is included in this portfolio upon written consent of the client.</p>
				</div>
			</div>
			<div id="resetaplus" className="screen">
				<div className="d-flex flex-row justify-content-center align-items-center h-100 w-50 m-0 p-0">
					<video width="50%" height="80%" autoPlay="true" loop="true" className="align-self-center" muted="true">
						<source src={ResetaPlus} type="video/mp4" />
					</video>
					<video width="50%" height="80%" autoPlay="true" loop="true" className="align-self-center" muted="true">
						<source src={ResetaPlusAuth2} type="video/mp4" />
					</video>
				</div>
				<div className="project-desc w-50">
					<OverlayTrigger placement="left" overlay={<div className="tooltip">Click to view source code.</div>}>
						<p className="project-title glitch" data-text="ResetaPlus: Mobile Healthcare Management System for Patients, Doctors, and Pharmacies" onClick={() => window.open('https://github.com/definitelynotpia/ResetaPlus', '_blank')}>
							ResetaPlus: Mobile Healthcare Management System for Patients, Doctors, and Pharmacies
						</p>
					</OverlayTrigger>
					<div className="d-flex flex-row justify-items between">
						<p className="project-subtitles w-50"><b>Date:</b> Aug 2025 - Nov 2024</p>
						<p className="project-subtitles w-50"><b>Type:</b> Course Work</p>
					</div>
					<p className="project-subtitles"><b>Roles:</b> Frontent developer, UI/UX designer</p>
					<p className="project-subtitles"><b>Technologies:</b> Flutter, Dart, SQL, XAMPP, VS Code</p>
					<p>ResetaPlus (stylized as Reseta+) is a mobile app that <span>digitizes prescription and medicine management</span>. The app serves as a tool for patients to track their medicine intake, lookup prescribed drugs or over-the-counter treatments for their current symptoms, and locate nearby pharmacies to purchase medicine from. Patients can generate QR codes of their repeated prescriptions for easy scanning and purchase at pharmacies. It also streamlines prescription authorization and follow-up consultations for doctors. The core idea of this app is to simplify and consolidate the three-way healthcare transactions between patients, doctors, and pharmacies for the convenience of all.</p>
					<button onClick={() => window.open('https://github.com/definitelynotpia/ResetaPlus', '_blank')} className="project-button">View source code</button>
				</div>
			</div>
			<div id="flutter" className="screen">
				<video width="50%" height="auto" autoPlay="true" loop="true" muted="true">
					<source src={FlutterPlayground} type="video/mp4" />
				</video>
				<div className="project-desc w-50">
					<OverlayTrigger placement="left" overlay={<div className="tooltip">Click to view source code.</div>}>
						<p className="project-title glitch" data-text="Flutter UI/UX Playground: A Self-Study on the Flutter Framework" onClick={() => window.open('https://github.com/definitelynotpia/FlutterUIChallenge', '_blank')}>
							Flutter UI/UX Playground: A Self-Study on the Flutter Framework
						</p>
					</OverlayTrigger>
					<div className="d-flex flex-row justify-items between">
						<p className="project-subtitles w-50"><b>Date:</b> Nov 2024 - Dec 2024</p>
						<p className="project-subtitles w-50"><b>Type:</b> Personal Project</p>
					</div>
					<p className="project-subtitles"><b>Roles:</b> Frontend developer</p>
					<p className="project-subtitles"><b>Technologies:</b> Flutter, Canva, VS Code</p>
					<p>This was a <span>personal project</span> conducted over the 3-week term break from late November to mid December back in 2024. After ResetaPlus, I wanted to <span>invest more time and energy in mastering the Flutter framework</span> as much as I could before the start of the new term. During this period, I learned a lot about Flutter layouts and widgets, alongside their respective hierarchies, attributes, applications, and ways to further customize the UI (such as the gradients you see here). I also challenged myself to take mobile UI templates from Canva and translate them into code as accurately as possible while giving certain elements functionality. <span>My journey with Flutter led me to fall in love with frontend development.</span></p>
					<button onClick={() => window.open('https://github.com/definitelynotpia/FlutterUIChallenge', '_blank')} className="project-button">View source code</button>
				</div>
			</div>
			<div id="sika-vue" className="screen">
				<div className="w-50 d-flex justify-content-center">
					<video width="85%" height="auto" autoPlay="true" loop="true" muted="true">
						<source src={SikaVue} type="video/mp4" />
					</video>
				</div>
				<div className="project-desc w-50">
					<OverlayTrigger placement="left" overlay={<div className="tooltip">Click to view source code.</div>}>
						<p className="project-title glitch" data-text="Sining Karamay: Conceptual Web-based App for Art Therapy and Journaling" onClick={() => window.open('https://github.com/definitelynotpia/sika-vue', '_blank')}>
							Sining Karamay: Conceptual Web-based App for Art Therapy and Journaling
						</p>
					</OverlayTrigger>
					<div className="d-flex flex-row justify-items between">
						<p className="project-subtitles w-50"><b>Date:</b> Jun 2024 - Jul 2024</p>
						<p className="project-subtitles w-50"><b>Type:</b> Course Work</p>
					</div>
					<p className="project-subtitles"><b>Roles:</b> Fullstack developer</p>
					<p className="project-subtitles"><b>Technologies:</b> Vue, Firebase, VS Code</p>
					<p>Sining Karamay (literally "Art Companion" in Filipino) is a conceptual web application that blends creative expression with wellness. The app explores the therapeutic benefits of art and journaling by giving users a digital space to paint, reflect, and keep a visual record of their emotions and experiences. For each artwork made, <span>the app remembers every point of color and can replay how the art was drawn</span>, to preserve the artist's "state of mind" that is visible in the art process. Because in Sining Kamay, <span>art and mental wellness is a journey worth embarking and documenting</span>.</p>
					<button onClick={() => window.open('https://github.com/definitelynotpia/sika-vue', '_blank')} className="project-button">View source code</button>
				</div>
			</div>
		</div>
	</div >);
}